import { Reveal } from "@/components/Reveal";

export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="grain mesh-light relative overflow-hidden border-b border-border">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
        <Reveal>
          {eyebrow && (
            <p className="text-sm font-semibold uppercase tracking-[0.15em] text-marigold-deep">{eyebrow}</p>
          )}
          <h1 className="mt-3 max-w-3xl font-heading text-4xl font-bold tracking-tighter text-foreground sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted-foreground sm:text-xl">
              {subtitle}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
